import { Component } from '@theme/component';

/**
 * Custom menu submenu desktop dropdown
 */
class stackMenu extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.open();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Open menu
   */
  open() {
    const details = this.querySelectorAll('details');
    details.forEach((detail) => {
      detail.addEventListener('mouseover', () => {
        // open one menu at a time 
        const activeDetail = this.querySelector('details[open]');
        activeDetail?.removeAttribute('open');  

        // hover to open menu
        detail.setAttribute('open','');

        this.close(detail);
      })
    });
  }

  /**
   * Close menu
   */
  close(detail) {
    detail.addEventListener('mouseout', () => {
      detail?.removeAttribute('open');  
    })
  }
}

if (!customElements.get('stack-menu')) {
  customElements.define('stack-menu', stackMenu);
}